import type { ContactType } from '@makemydeal/dr-platform-types';
import type { QualifiedPhoneNumbers } from '../phoneTypes';

export type DxgPhoneType = {
    phoneType: keyof QualifiedPhoneNumbers;
    contactType: ContactType;
    isMobile?: boolean;
};

export const DXG_PHONE_TYPES_BY_PRIORITY: readonly DxgPhoneType[] = [
    { phoneType: 'cellPhone', contactType: 'Personal', isMobile: true },
    { phoneType: 'homePhone', contactType: 'Personal', isMobile: false },
    { phoneType: 'workPhone', contactType: 'Work' }
];
